module.exports = __webpack_public_path__ + "static/media/1 9 shoulder batman joker large.1280x2276.c01c5d99.webp";